export * from './durchsuchen-list.component';
export * from './durchsuchen-list.component.module';